import { FC, useEffect } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useLocation } from 'react-router';

import Box from '@o2/ui/Box';

import { getCurrentRoute } from 'helpers/routes/routes';

export const PageTemplateReference: FC = () => {
  const location = useLocation();
  const pageData = getCurrentRoute()?.commonPageData;

  useEffect(() => {
    // triggers component re-render on location change
  }, [location]);

  // open HTML template in new tab
  useHotkeys(
    'ctrl+alt+h',
    (e: KeyboardEvent) => {
      e.preventDefault();

      if (pageData) {
        if (pageData?.templateUrl) {
          const win = window.open(pageData.templateUrl, '_blank');

          win?.focus();
        } else {
          alert('Odkaz na šablonu není k dispozici.');
        }
      }
    },
    [location]
  );

  // show alert with WF ID and URL to HTML template
  useHotkeys(
    'ctrl+alt+w',
    (e: KeyboardEvent) => {
      e.preventDefault();

      if (pageData) {
        const wfLink = pageData.templateUrl || 'Není k dispozici.';
        const alertText = pageData.pageId
          ? `Wireframe number: ${pageData.pageId}\n\nWireframe link: ${wfLink}\n\nZobrazení šablony: CTRL + ALT + H`
          : 'Tato stránka neobsahuje informace o příslušném wireframe.';

        alert(alertText);
      }
    },
    [location]
  );

  return (
    <Box
      id="o2soc-wireframe-ident"
      data-wf-number={pageData?.pageId}
      data-wf-link={pageData?.templateUrl}
      style={{ display: 'none' }}
    />
  );
};
